import _ from 'lodash'

const getAllIds = (allItems) => {
  let allIds = []
  allItems.map(item => {
    allIds.push(item.id)
  })
  return allIds
}

const isAll = (ids, allIds) => {
  let isAll = false
  if (_.intersection(ids, allIds).length === allIds.length && allIds.length > 0) {
    isAll = true
  }
  return isAll
}

export {
  getAllIds,
  isAll
}
